import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link
              to="/"
              className="flex items-center gap-2 text-lg font-bold text-primary"
            >
              <svg width="24" height="24" viewBox="0 0 28 28" fill="none">
                <rect width="28" height="28" rx="6" className="fill-primary" />
                <rect x="6" y="6" width="7" height="7" rx="1" className="fill-primary-foreground" />
                <rect x="15" y="6" width="7" height="7" rx="1" className="fill-primary-foreground" />
                <rect x="6" y="15" width="7" height="7" rx="1" className="fill-primary-foreground" />
                <rect x="17" y="17" width="3" height="3" rx="0.5" className="fill-primary-foreground" />
              </svg>
              AssistByScan
            </Link>
            <p className="mt-3 max-w-md text-sm text-muted-foreground">
              {t(
                "footer.description",
                "Digitalisez vos interventions techniques avec une plateforme web et mobile pensée pour la maintenance terrain."
              )}
            </p>
          </div>

          <div>
            <h3 className="mb-3 text-sm font-semibold text-foreground">
              {t("nav.features", "Fonctionnalités")}
            </h3>
            <div className="flex flex-col gap-2">
              <Link
                to="/features"
                className="text-sm text-muted-foreground transition-colors hover:text-primary"
              >
                {t("nav.features", "Fonctionnalités")}
              </Link>
              <Link
                to="/how-it-works"
                className="text-sm text-muted-foreground transition-colors hover:text-primary"
              >
                {t("nav.howItWorks", "Comment ça marche")}
              </Link>
              <Link
                to="/pricing"
                className="text-sm text-muted-foreground transition-colors hover:text-primary"
              >
                {t("nav.pricing", "Tarifs")}
              </Link>
            </div>
          </div>

          <div>
            <h3 className="mb-3 text-sm font-semibold text-foreground">
              {t("nav.contact", "Contact")}
            </h3>
            <div className="flex flex-col gap-2">
              <Link
                to="/contact"
                className="text-sm text-muted-foreground transition-colors hover:text-primary"
              >
                {t("nav.contact", "Contact")}
              </Link>
              <Link
                to="/download"
                className="text-sm text-muted-foreground transition-colors hover:text-primary"
              >
                {t("download_app", "Télécharger l'application")}
              </Link>
              <a
                href="mailto:contact@assistbyscan.com"
                className="text-sm text-muted-foreground transition-colors hover:text-primary"
              >
                contact@assistbyscan.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-border pt-6 text-center text-sm text-muted-foreground">
          {t(
            "footer.rights",
            "© 2026 AssistByScan — par SEZAIA, Brest. Tous droits réservés."
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
